/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Guestlist_FunnelInputs */

const en_scene_guestlist_funnel = /** @type {(inputs: Scene_Guestlist_FunnelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`February Market`)
};

/**
* | output |
* | --- |
* | "February Market" |
*
* @param {Scene_Guestlist_FunnelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_guestlist_funnel = /** @type {((inputs?: Scene_Guestlist_FunnelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Guestlist_FunnelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_guestlist_funnel(inputs)
});